import { Injectable } from '@angular/core';

const CHECK_INTERVAL = 15000; // in ms
const STORE_KEY = 'lastAction';
@Injectable()
export class AutoLogoutService {
  constructor() {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.initListener();
  }

  private getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  private setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  private initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('scroll', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
  }

  private _timer: ReturnType<typeof setTimeout> = null;

  reset() {
    this.setLastAction(Date.now());
  }

  start() {
    if (this._timer !== null) return;

    this._timer = setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  stop() {
    if (this._timer === null) return;

    clearTimeout(this._timer);
    this._timer = null;
  }

  public onTimeout = function onTimeout() {};
  public timeoutInMinutes = 12 * 60; // 12 hours by default.

  private check() {
    if (this.timeoutInMinutes === 0) return;
    const now = Date.now();
    const timeleft = this.getLastAction() + this.timeoutInMinutes * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout) {
      localStorage.clear();
      this.onTimeout();
    }
  }
}
